import { render, staticRenderFns } from "./ReportesView.vue?vue&type=template&id=97bac314"
import script from "./ReportesView.vue?vue&type=script&lang=js"
export * from "./ReportesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports